const CopyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.167" d="M16.541 4.704V9.84h4.678" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.167" d="M16.093 4.696H6.772v18.608H21.23V9.852l-4.693-5.156z" />
  </svg>
)

export default CopyIcon
